import React from 'react';
import { twMerge } from 'tailwind-merge';
import { Color } from '@diritto/common/style/color';
import { NewIconProps } from '@diritto/common/style/icon';

export const ArrowDoubleDownIcon = ({ className, color = Color.White }: NewIconProps) => (
  <svg
    className={twMerge('size-[16px]', className)}
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.09425 3.55834L6.87758 8.34751L11.6667 3.55834L10.8442 2.73584L6.87758 6.69667L2.91675 2.73584L2.09425 3.55834Z"
      fill={color}
    />
    <path
      d="M2.09425 6.47484L6.87758 11.264L11.6667 6.47484L10.8442 5.65234L6.87758 9.61318L2.91675 5.65234L2.09425 6.47484Z"
      fill={color}
    />
  </svg>
);
